module.exports = __webpack_public_path__ + "img/icon-user.f229e48f.svg";